import { Component, ojs, app, payload, state, v, component } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import {
    pageInfo,
    empty,
    inform,
    insertSpaces,
    eParse,
    closeModal,
    either,
    cleanDispose,
} from "../../helpers";
import { api, PAGES, STRINGS } from "../../declarations";
import SolidIcon from "../Blocks/SolidIcon";
import Modal from "../Blocks/Modal";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");

ojs(Modal);

export default class HashtagLocations extends Component {
    render(...args) {
        pageInfo(PAGES.HASHTAGS_LOCATION);
        return h.div(
            { class: "pb-5 mb-5 container d-flex flex-column gap-3" },
            h.div(
                { class: "bg-white rounded p-3 d-flex flex-column gap-3" },
                h.span(
                    { class: "d-flex justify-content-between" },
                    h.h4({ class: "" }, "Hashtags"),
                    h.span(
                        {
                            class: "text-danger",
                            role: "button",
                            listeners: {
                                click: () =>
                                    dom.empty(dom.id("hlac-hashtags-holder")),
                            },
                        },
                        "Clear",
                    ),
                ),
                h.div({
                    class: "rounded d-flex gap-2 flex-wrap",
                    id: "hlac-hashtags-holder",
                }),
                h.button(
                    {
                        class: "btn btn-outline-primary d-flex justify-content-center gap-2",
                        onclick: this.method("showHashtags"),
                    },
                    h.span({ class: "center" }, h.SolidIcon("plus")),
                    h.span("Add Hashtag"),
                ),
            ),
            h.div(
                { class: "bg-white rounded p-3 d-flex flex-column gap-3" },
                h.span(
                    { class: "d-flex justify-content-between" },
                    h.h4({ class: "" }, "Locations"),
                    h.span(
                        {
                            class: "text-danger",
                            role: "button",
                            listeners: {
                                click: () =>
                                    dom.empty(dom.id("hlac-locations-holder")),
                            },
                        },
                        "Clear",
                    ),
                ),

                h.div({
                    class: "rounded d-flex flex-column gap-2",
                    id: "hlac-locations-holder",
                }),
                h.button(
                    {
                        class: "btn btn-outline-primary d-flex justify-content-center gap-2",
                        onclick: this.method("openMap"),
                    },
                    h.span({ class: "center" }, h.SolidIcon("location-dot")),
                    h.span("Add Location"),
                ),
            ),
            h.button(
                {
                    class: "btn btn-success d-block",
                    onclick: this.method("saveLocations"),
                },
                "Save",
            ),
            ...args,
        );
    }

    showHashtags() {
		if(this.modalHolder) {
			cleanDispose(this.modalHolder);
		}
		
        this.modalHolder = tool.plainModal(h.HashtagSearchModal({parentId: this.id}));
        this.modalHolder.show();
    }

    addHashtagToList(tag) {
        h.HLHashtag(tag, { parent: dom.id("hlac-hashtags-holder") });
    }

    openMap() {
        broker.send($e.location.is.needed, payload({}, { from: "HLAC" }));
    }

	$$hashtag = {
		name: {
			available: (ed, event) => {
				this.modalHolder?.hide();	
			}
		}
	}

    $$location = {
        is: {
            available: (ed, event) => {
                this.processLocation(ed, event);
            },
        },
    };

    processLocation(ed, event) {
        let { message, meta } = eParse(ed);

        if (meta.from != "HLAC") return;

        h.HLLocation(message, { parent: dom.id("hlac-locations-holder") });
    }

    saveLocations() {
        let hashtags = {};
        let locations = [];

        dom.all(`[data-carata-hashtag-h="true"]`).forEach((elem) => {
            let ht = elem.getAttribute("data-carata-hashtag");
            hashtags[ht] = true;
        });

        dom.all(`[data-carata-location="true"]`).forEach((elem) => {
            let lat = elem.getAttribute("data-carata-lat");
            let lng = elem.getAttribute("data-carata-lng");

            locations.push({ latitude: lat, longitude: lng });
        });

        hashtags = Object.keys(hashtags);

        if (empty(hashtags) || empty(locations)) {
            return inform(
                "Please enter hashtags or locations to save",
                STRINGS.ERROR,
            );
        }

        broker.send(
            $e.hashtag.location.needs.storage,
            payload({ hashtags, locations }),
        );
    }
}

export class HashtagSearchModal extends Component {
    modalState = state({
        query: "",
        suggestions: [],
        selected: {},
    });

    constructor() {
        super();
        this.modalState.listener(this);
    }

    render(config, ...args) {
        this.parentPageId = config.parentId;

        return h.$(
            h.div(
                { class: "modal-content border-0 rounded-4 shadow bg-white" },
                h.div(
                    {
                        class: "modal-header border-0 pb-0 justify-content-between align-items-center",
                    },
                    h.h5(
                        { class: "modal-title fw-bold text-dark fs-5" },
                        "Add Hashtags",
                    ),
                    h.button({
                        type: "button",
                        class: "btn-close shadow-none",
                        data_bs_dismiss: "modal",
                        aria_label: "Close",
                    }),
                ),
                h.div(
                    { class: "modal-body pt-3" },
                    h.div(
                        { class: "d-flex flex-column gap-3" },
                        h.div(
                            { class: "input-group" },
                            h.span(
                                {
                                    class: "input-group-text bg-white border-end-0",
                                },
                                h.SolidIcon("search"),
                            ),
                            h.input({
                                type: "text",
                                class: "form-control border-start-0 ps-0",
                                placeholder: "Search or type hashtag...",
                                value: this.modalState.value.query,
                                listeners: {
                                    input: (e) => this.onSearchInput(e.target),
                                },
                            }),
                        ),
                        v(this.modalState, (ms) => {
                            const query = ms.value.query;
                            const sugs = ms.value.suggestions;
                            const sel = ms.value.selected;

                            const keys = Object.keys(sel);
                            const previewSection =
                                keys.length === 0
                                    ? null
                                    : h.div(
                                          {
                                              class: "d-flex gap-2 flex-wrap border-bottom pb-2",
                                          },
                                          ...keys.map((tag) =>
                                              h.span(
                                                  {
                                                      class: "badge bg-primary d-flex align-items-center gap-1 py-2 px-3 rounded-pill",
                                                  },
                                                  `#${tag}`,
                                                  h.span(
                                                      {
                                                          class: "text-white ms-1",
                                                          role: "button",
                                                          listeners: {
                                                              click: () =>
                                                                  this.toggleTag(
                                                                      tag,
                                                                  ),
                                                          },
                                                      },
                                                      h.i({ class: "bi bi-x" }),
                                                  ),
                                              ),
                                          ),
                                      );

                            const items = [];
                            const normalizedQuery = query
                                .trim()
                                .replace(/^#/, "");

                            if (normalizedQuery.length > 0) {
                                const exists = sugs.some(
                                    (s) =>
                                        s.name.toLowerCase() ===
                                        normalizedQuery.toLowerCase(),
                                );
                                if (!exists) {
                                    items.push(
                                        this.renderSuggestionItem(
                                            normalizedQuery,
                                            true,
                                            sel[normalizedQuery],
                                        ),
                                    );
                                }
                            }

                            sugs.forEach((sug) => {
                                items.push(
                                    this.renderSuggestionItem(
                                        sug.name,
                                        false,
                                        sel[sug.name],
                                    ),
                                );
                            });

                            const listSection =
                                items.length === 0
                                    ? h.div(
                                          {
                                              class: "text-muted text-center py-4",
                                          },
                                          "Type to search hashtags...",
                                      )
                                    : h.div(
                                          {
                                              class: "d-flex flex-column gap-2 overflow-auto",
                                              style: "max-height: 250px;",
                                          },
                                          ...items,
                                      );

                            return h.div(
                                { class: "d-flex flex-column gap-3" },
                                previewSection,
                                listSection,
                            );
                        }),
                    ),
                ),
                h.div(
                    { class: "modal-footer border-0 pt-0" },
                    h.button(
                        {
                            class: "btn btn-primary w-100",
                            listeners: {
                                click: () => this.addSelectedTags(),
                            },
                        },
                        "Add Selected",
                    ),
                ),
            ),
        );
    }

    renderSuggestionItem(name, isNew, isChecked) {
        return h.div(
            {
                class: `d-flex align-items-center justify-content-between p-2 rounded border cursor-pointer hover-bg-light ${isChecked ? "border-primary bg-primary-subtle" : ""}`,
                listeners: {
                    click: () => this.toggleTag(name),
                },
            },
            h.span(
                { class: "fw-medium" },
                `#${name}`,
                isNew
                    ? h.span({ class: "badge bg-success ms-2 font-xs" }, "New")
                    : null,
            ),
            h.input(
                {
                    class: "form-check-input",
                    type: "checkbox",
                    onclick: (e) => e.stopPropagation(),
                },
                either(isChecked, { checked: true }),
            ),
        );
    }

    async onSearchInput(elem) {
        const query = elem.value.trim().replace(/^#/, "");

        try {
            const res = await api.get(`mentions/suggest/tags`, { term: query });
            let suggestions = [];
            if (res && res.data) {
                suggestions = res.data.suggestions || [];
            }

            this.modalState.value = {
                ...this.modalState.value,
                query: elem.value,
                suggestions,
            };
        } catch (e) {
            console.error(e);
        }
    }

    toggleTag(name) {
        const copy = { ...this.modalState.value.selected };
        if (copy[name]) {
            delete copy[name];
        } else {
            copy[name] = true;
        }

        this.modalState.value = {
            ...this.modalState.value,
            selected: copy,
        };
    }

    addSelectedTags() {
        if (this.parentPageId) {
			let parentPage = component(this.parentPageId);
            Object.keys(this.modalState.value.selected).forEach((tag) => {
                parentPage.addHashtagToList(tag);
            });
        }

		broker.send($e.hashtag.name.available);
    }
}

function HLHashtag(hashtag, ...args) {
    return h.span(
        {
            class: "d-flex gap-2 justify-content-between border rounded-pill align-items-center bg-light h-100",
        },
        h.span(
            {
                class: "text-sm ps-2",
                data_carata_hashtag_h: true,
                data_carata_hashtag: hashtag,
            },
            insertSpaces(hashtag),
        ),
        h.span(
            {
                class: "center text-danger px-2",
                listeners: {
                    click: function () {
                        this.parentElement?.remove();
                    },
                },
            },
            h.SolidIcon("close"),
        ),
        ...args,
    );
}

function HLLocation(location, ...args) {
    let name = location.address;
    let latitude = location.latitude;
    let longitude = location.longitude;

    return h.span(
        {
            class: "d-flex gap-2 p-2 justify-content-between border rounded align-items-center bg-light",
        },
        h.span(
            {
                class: "text-sm",
                data_carata_location: true,
                data_carata_lat: latitude,
                data_carata_lng: longitude,
            },
            name,
        ),
        h.span(
            {
                class: "center text-danger p-2",
                listeners: {
                    click: function () {
                        this.parentElement?.remove();
                    },
                },
            },
            h.SolidIcon("close"),
        ),
    );
}

ojs(HashtagLocations, HashtagSearchModal, HLHashtag, HLLocation, SolidIcon);
